<template>
	<div>
		<view-detail @setting="setting" :bg="true" ref='myPage'></view-detail>
		<newPlantLight ref="newPlantLight" @AfterNew="afterNewPlant" v-if="SonComponents.newPlant" @Close="SonComponents.newPlant=false"></newPlantLight>
		<newPlantWind ref="newPlantWind" @AfterNew="afterNewPlantWind" v-if="SonComponents.newPlant" @Close="SonComponents.newPlant=false"></newPlantWind>
		<message-box ref='messageBox' :bg="true"></message-box>
		<div id="head" class='tra' :style="{top:top}">
			<div class="content cb fL_E tra-fast_E">
				<div class="logoBox taC tra">
					<div class="logo" :style="{backgroundImage:'url('+(stage.loc.logo.system[stage.languageId]?stage.loc.logo.system[stage.languageId]:stage.loc.logo.system.public)+')'}"></div>
				</div>
				<!--
				<transition name="fade" mode="out-in" :duration="{enter:500,leave:200}">
					<div v-show="stage.setting.sideMode==='min'" class="logo logo-whiteMin"></div>
				</transition>
				<transition name="fade" mode="out-in" :duration="{enter:500,leave:200}">
					<div v-show="stage.setting.sideMode==='def'" class="logo logo-white"></div>
				</transition>
				<router-link tag="div" to="/work" class="hasDropList-hover tra-fast vaM_E">
					<router-link class="tra-fast fs12x" to="/work/home">{{$t("word1189",["工作"])}}</router-link>
				</router-link>
			<router-link tag="div" to="/client" class="hasDropList-hover tra-fast vaM_E" :class="{active:resetRouteClass('client')}" v-permissions="'B'" permission-type="none">
				<router-link class="tra-fast fs12x" to="/client/home">{{$t("word1183",["客户"])}}</router-link>
				<div class="dropList bgMain tra-fast cb tra-fast_E">
					<router-link to="/client/newClient">{{getLanguageStr('crm42','新建客户')}}</router-link>
					<router-link to="/client/newClue">{{getLanguageStr('assess5','新建线索')}}</router-link>
				</div>
			</router-link>
			<div class="hasDropList-hover tra-fast vaM_E" :class="{active:resetRouteClass('bench')}">
				<a class="tra-fast fs12x class-btn" id="bench">{{$t('word1445',['工作台'])}}</a>
				<div class="arrow tra-fast"></div>
				<div class="dropList appList tra-fast">
					<div class="list colorSys boxR bgContent bdSub tra-fast_E">
						<div class="bdSub-bottom pb05x cSub mb1x">{{getLanguageStr('word1980',['我的应用'])}}</div>
						<router-link to="/bench/evaluation" :title="$t('word1265',['评估'])">
							<div class="icoSys colorBg2 fWhite">
								<svg><use xlink:href="#ico-evaluation"></use></svg>
							</div>
							{{$t('word1265',['评估'])}}
						</router-link>
						<router-link to="/bench/approval" :title="$t('word1317',['审批'])" >
							<div class="icoSys colorBg3 fWhite">
								<svg><use xlink:href="#ico-approval"></use></svg>
							</div>
							{{$t('word1317',['审批'])}}
						</router-link>
					</div>
				</div>
			</div>
			 -->

				<router-link tag="div" v-permissions="'A'" permission-type="none" v-if="doLayoutRole('1',businessType)&&getRoute('maintainRoutesDic').length" :to="{path: getRoute('maintainRoutesDic')[0]['route']}" class="style-navMenu hasDropList-hover tra-fast vaM_E" :class="{active:resetRouteClass('maintain')}">
					<a class="tra-fast fs12x class-btn" id="maintain" onclick="">{{$t("word1184",["运维"])}}</a>
				</router-link>
				<router-link v-permissions="'B'" permission-type="none" v-if="doLayoutRole('2',businessType)&&getRoute('deviceRoutesDic').length>0" tag="div" :to="{path: getRoute('deviceRoutesDic')[0]['route']}" class="style-navMenu hasDropList-hover tra-fast vaM_E" :class="{active:resetRouteClass('device')}">
					<a class="tra-fast fs12x class-btn" id="device">{{$t('device5',['设备库'])}}</a>
				</router-link>

				<router-link v-permissions="'E'" permission-type="none" v-if="doLayoutRole('3',businessType)&&getRoute('productRoutesDic').length>0" :to="{path: getRoute('productRoutesDic')[0]['route']}" tag="div" class="style-navMenu hasDropList-hover tra-fast vaM_E" :class="{active:resetRouteClass('product')}">
					<a class="tra-fast fs12x class-btn" id="prodruct">{{$t('word1532',['产品'])}}</a>
				</router-link>
				<!--
			<router-link tag="div" to="/project/home" class="hasDropList-hover tra-fast vaM_E" :class="{active:resetRouteClass('project')}">
				<a class="tra-fast fs12x class-btn" id="project">{{$t('word1202',['项目'])}}</a>
			</router-link> v-if="stage.loc.customer=='SOLARMAN'&&userInfo.organization.areaId==44"
			 -->
       <!-- <router-link  :to="{path: '/working'}" tag="div" class="style-navMenu hasDropList-hover tra-fast vaM_E" :class="{active:resetRouteClass('working')}">
					<a class="tra-fast fs12x class-btn" id="prodruct">{{$t('crm59',['工作'])}}</a>
				</router-link> -->
				<router-link v-if="doLayoutRole('4',businessType)" tag="div" v-permissions="'C/A'" permission-type="none" class="style-navMenu hasDropList-hover tra-fast vaM_E" :class="{active:resetRouteClass('application')}" to="/application">
					<a class="tra-fast fs12x class-btn" id="application" onclick="statistic('A16','A17')">{{$t('word1291',['应用'])}}</a>
					<Icon name="tipArrow" class="ico w2x h2x ml1x tipArrow sSub" />
					<div class="dropList appList tra-fast">
						<div class="list colorSys boxR bgContent bdSub cb fL_E tra-fast_E">
							<div class="w100pct mb05x cSub">{{getLanguageStr('word1822',['常用应用'])}}</div>
							<router-link v-permissions="'C/B'" permission-type="none" v-if='!stage.setting.loc.shieldBlackList.display' to="/application/screen" :title="$t('word1868',['大屏'])">
								<div class="ico boxR ofH" onclick="statistic('A16','A38')">
									<Icon name="app-display" />
								</div>
								{{$t('word1868',['大屏'])}}
							</router-link>
							<router-link v-permissions="'C/D'" permission-type="none" to="/application/report" :title="$t('word1290',['报表'])" v-if='!stage.setting.loc.shieldBlackList.report'>
								<div class="ico boxR ofH" onclick="statistic('A16','A39')">
									<Icon name="app-report" />
								</div>
								{{$t('word1290',['报表'])}}
							</router-link>
							<router-link v-if="stage.loc.customer=='SOLARMAN'&&userInfo.organization.areaId==44" to="/application/sim" :title="$t('word1503',['SIM卡充值'])">
								<div class="ico boxR ofH" onclick="statistic('A16','A40')">
									<Icon name="app-sim" />
								</div>
								{{$t('word1503',['SIM卡充值'])}}
							</router-link>
							<!-- <router-link v-if="stage.loc.customer=='SOLARMAN'&&userInfo.organization.areaId==44" to="/application/insurance" :title="$t('word1663',['保险'])">
							<div class="ico boxR ofH">
								<Icon name="app-insurance" />
							</div>
							{{$t('word1663',['保险'])}}
						</router-link> -->
							<router-link v-permissions="'C/A/A5'" permission-type="none" v-if="!stage.setting.loc.shieldBlackList.maintenance" to="/application/maintenance" :title="$t('word1992',['维保记录'])">
								<div class="ico boxR ofH" onclick="statistic('A16','A41')">
									<Icon name="app-maintenance" />
								</div>
								{{$t('word1992',['维保记录'])}}
							</router-link>
							<router-link v-if="stage.loc.customer=='SOLARMAN'&&userInfo.organization.areaId==44&&!stage.setting.loc.shieldBlackList.virtualWeatherStation" to="/application/virtualWeatherStation" :title="$t('station1',['虚拟气象站'])">
								<div class="ico boxR ofH" onclick="statistic('A16','A43')">
									<Icon name="app-virtualWeatherStation" />
								</div>
								{{$t('station1',['虚拟气象站'])}}
							</router-link>
							<router-link v-permissions="'C/C'" permission-type="none" v-if="stage.loc.customer=='SOLARMAN'&&userInfo.organization.areaId==44&&!stage.setting.loc.shieldBlackList.inspect" to="/application/inspect" :title="$t('word1979',['体检'])">
								<div class="ico boxR posR ofH" onclick="statistic('A16','A44')">
									<Icon name="app-inspect" />
									<!-- <div class="lf">{{$t('app1',['限免'])}}</div> -->
								</div>
								{{$t('word1979',['体检'])}}<br><span class="cDanger dpIB">({{$t('app1',['限免'])}})</span>
							</router-link>
							<router-link v-if="!stage.setting.loc.shieldBlackList.networking" to="/application/network" :title="$t('Networking1',['组网'])">
								<div class="ico boxR ofH">
									<Icon name="app-networking" />
								</div>
								{{$t('Networking1',['组网'])}}
							</router-link>
							<router-link v-permissions="'C/G'" permission-type="none" v-if="stage.setting.loc.shieldWhiteList.app.IVCurveItemStruct" to="/application/ivcurve" :title="$t('device257',['IV曲线'])">
								<div class="ico boxR ofH">
									<Icon name="app-ivScan" />
								</div>
								 {{$t('device257',['IV曲线'])}}
							</router-link>
							<router-link v-if="stage.setting.loc.shieldWhiteList.app.electricity&&userInfo.organization.areaId==44" to="/application/electricity/home" :title="$t('bill1',['电费记录'])" v-permissions="'C/F/A2'" permission-type="none">
								<div class="ico boxR ofH">
									<Icon name="app-electricity" />
								</div>
								{{$t('bill1',['电费记录'])}}
							</router-link>
							<router-link v-if="stage.setting.loc.shieldWhiteList.app.distributions&&userInfo.organization.areaId==44" to="/application/distributions" :title="$t('app54',['全国光伏资源区分布'])">
								<div class="ico boxR ofH">
									<Icon name="distr" />
								</div>
								{{$t('app54',['全国光伏资源区分布'])}}
							</router-link>
							<router-link to="/application" :title="getLanguageStr('app5','更多应用')">
								<div class="ico boxR ofH">
									<Icon name="app-more" />
								</div>
								{{getLanguageStr('app5','更多应用')}}
							</router-link>
						</div>
					</div>
				</router-link>
				<router-link tag="div" v-permissions="'D'" permission-type="none" v-if="doLayoutRole('5',businessType)&&getRoute('manageRoutesDic').length" :to="{path: getRoute('manageRoutesDic')[0]['route']}" class="style-navMenu hasDropList-hover tra-fast vaM_E" :class="{active:resetRouteClass('manage')}">
					<a class="tra-fast fs12x class-btn" id="manage">{{$t('word1429',['管理'])}}</a>
				</router-link>
				<div class="hasDropList-hover tra-fast vaM_E dpN">
					<a class="tra-fast fs12x">SIM{{getLanguageStr('word1429','管理')}}</a>
					<div class="dropList bgMain tra-fast cb tra-fast_E">
						<router-link to="/sim/basicInfo">{{getLanguageStr('word1642','基础信息')}}</router-link>
						<router-link to="/sim/card">{{$t('word1446',['卡管理'])}}</router-link>
					</div>
				</div>
				<!--
			<router-link v-if="stage.loc.customer=='fupin'" tag="div" to="/collectorFastConfig" class="hasDropList-hover tra-fast vaM_E" :class="{active:resetRouteClass('collectorFastConfig')}">
				<a class="tra-fast fs12x class-btn" id="collectorFastConfig">扶贫</a>
			</router-link>
			 -->
				<div class="fR tra-fast cb vaM_E">
					<div v-permissions="'A/B/A2'" permission-type="none" class="hasDropList-hover tra-fast fL pl1x pr1x vaM_E">
						<!-- <button @click="newPlant" class="posR" :title="getLanguageStr('cmd182','新建电站')">
					</button> -->
						<Icon name="add" class="w1x h1x fNeutral" />
						<div class="dropList bgContent tra-fast tra-fast_E hover-bg-highLight_E" v-if='userInfo.organization.operateObject.indexOf("2") === -1'>
							<a class="taC-imp pl2x-imp pr2x-imp" @click="newPlant('PV')" :title="getLanguageStr('cmd182','新建电站')">{{getLanguageStr('cmd182','新建电站')}}</a>
						</div>
						<div class="dropList bgContent tra-fast tra-fast_E hover-bg-highLight_E" v-else>
							<a class="taC-imp pl2x-imp pr2x-imp" @click="newPlant('PV')" :title="getLanguageStr('all45','添加新光伏电站')">{{getLanguageStr('all45','添加新光伏电站')}}</a>
							<a class="taC-imp pl2x-imp pr2x-imp" @click="newPlant('WIND')" :title="getLanguageStr('all46','添加新风力电站')">{{getLanguageStr('all46','添加新风力电站')}}</a>
						</div>
					</div>
					<div class="fL" v-if="!stage.setting.loc.shieldBlackList.message">
						<button @click="showBox" class="posR pl1x pr1x">
							<span class="errorNum bgError" v-if="unreadNum>0">{{unreadNum>99?'99+':unreadNum}}</span>
							<Icon name="bell" class="w1x h1x fNeutral" />
						</button>
					</div>
					<div v-if="stage.loc.customer=='SOLARMAN'||stage.loc.operationManual.public" class="hasDropList-hover tra-fast fL pl1x pr2x vaM_E">
						<Icon name="help" class="w1x h1x fNeutral" />
						<div class="dropList bgContent tra-fast tra-fast_E hover-bg-highLight_E">
							<a v-if="stage.loc.customer=='SOLARMAN'" :href="'https://igen.udesk.cn/im_client/?web_plugin_id=33384&group_id=71152&language='+(stage.languageId=='zh'?'zh-cn&channel=zh':'en-us&channel=en')" class="taC-imp pl2x-imp pr2x-imp" target="_blank" :title="$t('me1',['我的客服'])">{{$t("me1",["我的客服"])}}</a>
							<a :href="manualUrl" class="bdSub-top taC-imp pl2x-imp pr2x-imp" target="_blank" :title="$t('me2',['操作手册'])">{{$t("me2",["操作手册"])}}</a>
						</div>
					</div>
					<div class="tra-fast fL vaM_E">
						<Select :styleType="'noBorder'" :list="stage.languageList" :bindActive="stage.languageId" @Click="i=>{setLanguageChage(stage.languageList[i].value);}"></Select>
					</div>
					<div class="user hasDropList-focus tra-fast fL fSub hover-f-main vaM_E" tabindex="-1" @click.stop="">
						<!-- <span v-if="userInfo.userInfo.photo" class="face" :style="{'background-image':'url('+userInfo.userInfo.photo+')'}"></span>
						<Icon v-else name="userFace" class="face" /> -->

            <div class='w3x h3x ml1x'  style="margin-top:6px">
              <Logo customClass='w3x h3x' :Logourl='userInfo.userInfo.photo' LogoType="person"/>
            </div>
						<!-- <span class="w8x-max textCut" :title="userInfo.userInfo.name">{{userInfo.userInfo.name}}</span> -->
						<!-- <span class="dpIB lh1"> -->
						<!-- <br> -->
						<!-- <span v-if="inRunType('C')" class="w8x-max textCut cSub" :title="getLanguageStr('word835',['小麦号'])+':'+userData.uid">{{getLanguageStr('word835','小麦号')+':'+userData.uid}}</span> -->
						<!-- </span> -->
						<!-- <Icon name="arrow-d" :sizeBase="'xxs'" class="w1x h1x" /> -->
						<!-- <span class="fa fa-angle-down ml5 cSub"></span> -->
						<div class="dropList bgContent tra-fast tra-fast_E hover-bg-highLight_E">
							<div class="vaM_E dpIB_E">
								<div class="pr1x">
									<!-- <span v-if="userInfo.userInfo.photo" class="face" :style="{'background-image':'url('+userInfo.userInfo.photo+')'}"></span>
									<Icon v-else name="userFace" class="face" /> -->
                   <div class='w4x h4x mr1x ml1x'>
                    <Logo customClass='w4x h4x' :Logourl='userInfo.userInfo.photo' LogoType="person"/>
                  </div>
								</div>
								<div class="w13x-max textCut_E ">
									<div class="fs14x lh15" :title="userInfo.userInfo.name||''">{{userInfo.userInfo.name||''}}</div>
									<p class="cSub lh20" style="margin-bottom: 0" :title="getTypeText(userInfo.orgUser.roleId,'roleType')||userInfo.roleName">{{getTypeText(userInfo.orgUser.roleId,'roleType')||userInfo.roleName}}</p>
								</div>
							</div>
							<button id="myHomepage" class="bdLight-top fs12x" :title="$t('cmd253',['我的主页'])" @click="myHomepage" onclick="statistic('A22','A51')" type="button">{{$t("cmd253",["我的主页"])}}</button>
							<button id="setting" class="bdLight-top fs12x" :title="$t('user4',['个人设置'])" @click="setting">{{$t('user4',['个人设置'])}}</button>
							<button id="logout" class="bdLight-top fs12x" :title="$t('cmd17',['退出登录'])" onclick="statistic('A22','A2201')" @click="logout">{{$t("cmd17",["退出登录"])}}</button>
						</div>
					</div>
				</div>
				<div class="tool fR vaM_E tra-fast_E noSelect curP" v-if="false">
					<button class="msg" @click="$refs.Notice.show()">
						<span class="superscript superscript-absMode bgRed" v-if="unRead>0">{{unRead}}</span>
						<div class="ico-menu10 ui mc"></div>
					</button>
				</div>
			</div>
		</div>
		<Notice ref="Notice"></Notice>
	</div>
</template>
<script>
import DeviceViewDetail from '@/view/device/operationalAudit/ViewDetail.vue'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as lib from '@/util/lib'
import { setLanguage, getLanguageStr } from '@/util/language'
import { logout, SIMLogout } from '@/api/login'
import * as routesDic from '@/util/routesDic'
import Logo from '@/components/common/ui/Logo.vue';
import WindSiteDetail from '@/view/maintain/wind/plant/ViewDetail.vue'
import Notice from '@/view/frame/Notice.vue'
import Select from '@/components/common/ui/Select'
import ViewDetail from '@/components/common/account/ViewDetail'
import newPlantLight from '@/view/maintain/light/plant/part/New.vue';
import newPlantWind from '@/view/maintain/wind/plant/part/New.vue';
import ViewPlantDetail from '@/view/maintain/light/plant/ViewDetail.vue'
import { userMy } from '@/api/manage/user.js'
import * as roleFuncApi from '@/api/manage/roleFunc'
import MessageBox from '@/view/manage/message/Box'
import { getUnreadedTotal } from '@/api/manage/message.js'
import { changeLanguage } from '@/api/setting/my.js'
import { apiGetManual } from '@/api/base.js'

export default {
	name: 'Head',
	components: { Notice, Select, ViewDetail, newPlantLight,newPlantWind, ViewPlantDetail, MessageBox, Logo },
	data () {
		return {
			stage,
			// RoleA: false,
			// RoleB: false,
			// RoleD: false,
			businessType: '',
			userData: {
				name: '',
				uid: '213654'
			},
			unreadNum: 0,
			SonComponents: {
				newPlant: false
			},
			manualUrl: '',
			devMode: true // 开发模式
		}
	},
	watch: {
		'$route': 'getPath'
	},
	methods: {
		getTypeText: lib.getTypeText,
		doLayoutRole: lib.doLayoutRole,
		setLanguageChage (v) {
			new Promise((resolve, reject) => {
				changeLanguage(v).then(response => {
					resolve(response)
				}).then(function (response) {
					setLanguage(v)
				}).catch(error => {
					reject(error)
				})
			})
		},
		getUnreadedTotal () {
			if(!stage.setting.loc.shieldBlackList.message){
				getUnreadedTotal().then(res => {
							if (typeof res === 'number') {
								this.unreadNum = res
							}
						}, error => {
							!_.isEmpty(error) && this.$notify(error)
						})
			}
		},
		getPath () {
			this.getUnreadedTotal()
		},
		...mapActions({
		//	GETMSGLIST: 'inbox/GETMSGLIST',
			GETUSERINFO: 'user/getInfo',
			GetPreference: 'user/getPreference'
		}),
		...mapMutations({
			SETTOP: 'head/SETTOP'
		}),
		setLanguage: setLanguage,
		getLanguageStr: getLanguageStr,
		inRunType: lib.inRunType,
		doPermissions: lib.doPermissions,
		showBox () {
			this.$refs.messageBox.show()
		},
		myHomepage () {
			this.$refs.myPage.show(this.userInfo)
		},
		setting () {
			this.$router.push('/setting')
		},
		logout () {
			// if (this.$route.path.indexOf('/sim') > -1) {
			//   SIMLogout('/sim/logout', {}).then(res => {
			//     this.$router.push({
			//       path: '/simLogin'
			//     })
			//   })
			// }
			// else {
			logout().then(() => {
				if (lib.getCookie('type')) lib.setCookie('type', '')// 清空二合一设置
				this.$router.push('/login')// 路由系统决定是否到登录
				// if (stage.type.c) { // 存在C端，回到二合一页面
				// 	this.$router.push('/platformSelect')
				// } else {
				// }
			})
			// }
		},
		// 重定向路由
		getRoute (param) {
			if (param === 'maintainRoutesDic' && this.userInfo.organization.operateObject.indexOf('2') !== -1) {
				return [{ route: '/maintain/dataCockpit' }]
			}
			let res = []
			let { codeList } = this.userRoles
			if (codeList && codeList.length) {
				codeList = codeList.filter(_ => _.isOn !== 0).map(_ => _.code)
				routesDic[param].forEach(r => {
					if (codeList.includes(r.code)) {
						res.push(r)
					}
				})
			}
			return res
		},
		resetRouteClass (name) {
			return (name === this.$route.path.split('/')[1])
		},
		getMy () {
			// roleFuncApi.getRoleDetail(this.userInfo.orgUser.roleId).then(data => {
			//   // this.RoleA = false
			//   // this.RoleB = false
			//   // data.codeList.map(item => {
			//   //   if (item.code === 'A' && (item.isOn == 2 || item.isOn == 1)) {
			//   //     this.RoleA = true
			//   //   } else {
			//   //     // this.RoleA = false
			//   //   }
			//   //   if (item.code === 'B' && (item.isOn == 2 || item.isOn == 1)) {
			//   //     this.RoleB = true
			//   //   } else {
			//   //     // this.RoleB = false
			//   //   }
			//   //   if (item.code === 'D' && (item.isOn == 2 || item.isOn == 1)) {
			//   //     this.RoleD = true
			//   //   } else {
			//   //     // this.RoleB = false
			//   //   }
			//   // })
			//   // console.log(this.RoleA, this.RoleB)
			// })
			this.GETUSERINFO().then(_ => {
				this.businessType = this.userInfo.organization.businessType
			})

			// userMy().then(data => {
			//   this.businessType = data.org.businessType
			// })
		},
		newPlant (powerType="PV") {
			// console.log(this.$route.path)
			// this.GET_PROJECTID({type: 'projectDetail/GET_PROJECTID', projectId: null})
			
				this.SonComponents.newPlant = true
				setTimeout(() => {
					switch(powerType){
						case "PV":
							this.$refs.newPlantLight.modeChange('new');
							this.$refs.newPlantLight.open();
							break;
						case "WIND":
							this.$refs.newPlantWind.modeChange('new');
							this.$refs.newPlantWind.open();
							break;
					}
				}, 50);
			
    },
    afterNewPlantWind: function (data) { // 新建好电站要干的事情
			// this.getList()	//若在列表页需刷新列表
			this.viewDetailWind(data)	// 打开新建立电站的详情
			this.SonComponents.newPlant = false
    },
    viewDetailWind (data) {
			let buttonPermissions = JSON.parse(localStorage.getItem('buttonPermissions'))
			if (!buttonPermissions.includes('A/B/A6')) {
				this.$notify(getLanguageStr('phrase783', '你没有权限，请联系本商家超级管理员开启'))
				return false
			} else {
				// this.GET_STATIONID(data.id) // 获取列表id
				// this.CHANGE(2)
				// if (this.plantDetail) this.plantDetail.show(data)	//因详情为3级叠加层，所以必然关闭才能再次打开，所以每次打开都是动态创建
				// else {
				this.$dynamic(this.$el, WindSiteDetail, { bg: true }, {
				}).then(dynamic => {
					// this.plantDetail = dynamic.childInstance	//每次打开都是动态创建（无需记录）
					dynamic.childInstance.show(data, dynamic.instance)
				})
				// }
			}
		},
		afterNewPlant: function (data) { // 新建好电站要干的事情
			// this.getList()	//若在列表页需刷新列表
			this.viewDetail(data)	// 打开新建立电站的详情
			this.SonComponents.newPlant = false
		},
		viewDetail (data) {
			let buttonPermissions = JSON.parse(localStorage.getItem('buttonPermissions'))
			if (!buttonPermissions.includes('A/B/A6')) {
				this.$notify(getLanguageStr('phrase783', '你没有权限，请联系本商家超级管理员开启'))
				return false
			} else {
				// this.GET_STATIONID(data.id) // 获取列表id
				// this.CHANGE(2)
				// if (this.plantDetail) this.plantDetail.show(data)	//因详情为3级叠加层，所以必然关闭才能再次打开，所以每次打开都是动态创建
				// else {
				this.$dynamic(this.$el, ViewPlantDetail, { bg: true }, {
				}).then(dynamic => {
					// this.plantDetail = dynamic.childInstance	//每次打开都是动态创建（无需记录）
					dynamic.childInstance.show(data, dynamic.instance)
				})
				// }
			}
		},
		getManualUrl(){
			if(this.stage.loc.operationManual && this.stage.loc.operationManual.action === 'api'){
				apiGetManual().then(res=>{
					let fileUrl = '';
					for (let i = 0; i < res.length; i++) {
						if(stage.languageId === res[i].language) {
							fileUrl = res[i].fileUrl;
							break;
						}
					}
					this.manualUrl = fileUrl || this.stage.loc.operationManual[stage.languageId] || this.stage.loc.operationManual.public;
				})
			}else{
				this.manualUrl = this.stage.loc.operationManual[stage.languageId] || this.stage.loc.operationManual.public;
			}
		}
	},
	computed: {
		...mapGetters({
			userInfo: 'user/userInfo',
			userRoles: 'user/userRoles',
			unRead: 'inbox/unRead',
			top: 'head/getTop'
		})
	},
	created () {
		if (process.env.NODE_ENV === 'production') {
			this.devMode = false
		}
		this.getManualUrl()
	},
	destroyed () {
		this.$bus.$off('openViewdetailHead')
	},
	mounted () {
		this.getUnreadedTotal()
		this.getMy()
		this.GetPreference()
		this.$bus.$on('changeUnread', this.getUnreadedTotal)
		// this.$bus.$on('changeMyBus', this.getMy)
	//	this.GETMSGLIST()
		let { path } = this.$route

		if (path.startsWith('/sim')) {
			this.userData.name = '管理员'
		} else {
			// trace(this.userInfo)
			// this.userData.name = this.userInfo.orgUser.markName
    }
    this.$bus.$on('openViewdetailHead', (data,el) => {
			// this.SET_CURRENTINDEX(0)
			this.$dynamic(el, DeviceViewDetail, {bg: true, type: 1}, {}, {}).then(({instance, childInstance}) => {
				// this.sView.push({instance, childInstance})
				let dec = 1
				if (data.deviceType === 'COLLECTOR') {
					dec = 1
				} else {
					dec = 2
				}
				childInstance.show(data)
			})
		});

	}
}
</script>
<style lang="scss" scoped>
// .icoSys{
// 	svg{padding:14%;}
// }
#head {
	height: $headHeight;
	position: relative;
	color: $mainColorFont;
	@extend %boxShadowPublic;
	line-height: 3.8;
	z-index: 20;
	.logoBox {
		background-color: $headBgColor;
	}
	.content {
		height: 100%;
		left: 0;
		top: 0;
		background-color: $headBgColor;
		color: $headFontColorDef;
		> * {
			height: 100%;
			> .tipArrow {
				margin: {
					left: -1em;
				}
				position: absolute;
				left: 50%;
				transform: rotate(180deg);
				top: 2em;
				z-index: 7;
				opacity: 0;
			}
			> .arrow {
				min-width: unset;
				margin: {
					left: -1em;
				}
				padding: {
					top: 0;
					bottom: 0;
					left: 0;
					right: 0;
				}
				border-left: 1em solid $alpha;
				border-right: 1em solid $alpha;
				border-bottom: 1em solid $contentBgColor;
				position: absolute;
				bottom: 0;
				left: 50%;
				opacity: 0;
				z-index: 13;
				pointer-events: none;
			}
			&:hover .arrow {
				opacity: 1;
			}
			&:hover .tipArrow {
				opacity: 1;
			}
		}
		.style-navMenu {
			@extend %style-navMenu;
		}
		//		.title{position:relative;
		//			.name{max-width:10em;padding:{left:15px;};display:inline-block;font-size:1.4em;position:relative;z-index:2;@extend %textCut;}
		//		}
		/*[class*="hasDropList"]:hover,a:hover{box-shadow:0 -1em 4em rgba(0,0,0,.1) inset;}*/
		// a:hover{background-color:darken($mainColor,6%);}
		// >[class*="hasDropList"]:hover{background-color:darken($mainColor,6%);
		// 	>a{background-color:unset;}
		// }
		.active {
			background-color: $headMenuBgColorAct;
			color: $headFontColorAct; //background-color:darken($mainColor,8%);
			.active {
				background: none;
				box-shadow: none;
			} //避免双重激活带来的样式问题
		}
		//		.title-haveList{
		//			.name{cursor:pointer;}
		//
		//			&:before{content:"";width:100%;height:0;border:{left:1px solid $gray4;right:1px solid $gray4;};display:block;background-color:#fff;position:absolute;left:0;bottom:0;@extend %tra-fast;z-index:1;}
		//			.list{width:58em;padding:2em 0;border:1px solid $gray4;border-radius:0 $radius $radius $radius;position:absolute;left:0;top:98%;background-color:#fff;opacity:0;box-shadow:0 2px 10px rgba(#000,.1);pointer-events:none;visibility:hidden;
		//				>*{padding:0 40px;}
		//				a{width:15em;margin:0 2em 0 0;line-height:3;color:#000;@extend %textCut;}
		//				a:hover,[def]{color:$mainColor;}
		//				.subTitle{width:100%;margin:-1em 0 .6em 0;border-bottom:1px solid $gray5;color:#000;font-size:1.3em;display:block;}
		//			}
		//			&:hover{
		//				color:$mainColor;
		//
		//				&:before{height:4em;}
		//				.list{opacity:1;pointer-events:auto;visibility:visible;}
		//			}
		//		}

		> .fR {
			position: relative;
		}
		> .fR:after {
			content: "";
			display: block;
			height: 100%;
			border-left: 1px solid rgba(#000, 0.1);
			position: absolute;
			top: 0;
			left: 0;
		}
		> .fR:last-child:after {
			border-left: none;
		}

		.search {
			width: 22%;
			min-width: 200px;
			margin: {
				right: 2em;
			}
			padding: {
				left: 0;
				right: 0;
				top: 0.6em;
			}
			line-height: 1;
			[type="text"] {
				width: 100%;
				height: 2.5em;
				line-height: 2.4em;
				padding: 0 40px 0 1em;
				border: {
					left: none;
				}
				border-radius: $radius;
				background-color: rgba(#fff, 0.8);
				box-shadow: 1px 1px 2px rgba(#000, 0.1) inset;
				&:focus {
					background-color: #fff;
				}
			}
			.btn {
				height: 2.5em;
				margin: (-2.5em/1.8) 0 0 0;
				padding: 0 10px;
				line-height: 2.5em;
				position: absolute;
				right: 0;
				top: 50%;
				z-index: 1;
				opacity: 0.6;
			}
			.btn:hover {
				opacity: 1;
			}
			.list {
				top: 3.1em;
			}
		}

		.tool {
			> * {
				@include size(30px);
				margin: 0 20px 0 0;
				display: inline-block;
				position: relative;
				border-radius: 50%;
				border: 1px solid rgba(#fff, 0);
				&[onoff="open"] {
					border: 1px solid rgba(#fff, 0.8);
					position: relative;
					background-color: $greenLight;
				}
				&:hover {
					&:before,
					&:after,
					.ui:before,
					.ui:after {
						content: "";
						@include size(100%);
						display: block;
						border: 1px solid #fff;
						border-radius: 50%;
						position: absolute;
						top: -1px;
						left: -1px;
						animation: wave 1.6s ease-in-out infinite both;
					}
					&:after {
						animation-delay: 0.4s;
					}
					.ui:before {
						animation-delay: 0.8s;
					}
					.ui:after {
						animation-delay: 1.2s;
					}
				}
			}
			> *:last-child {
				margin-right: 0;
			}
			> div {
				padding: {
					top: 4px;
					bottom: 6px;
				}
			}

			.superscript-absMode {
				left: 1.6em;
			}

			.msg {
				.dropList {
					width: 23em;
					line-height: 1;
					.top:hover,
					.bottom:hover {
						color: inherit;
					}
					> * {
						padding: 1em;
					}
					[scroll] {
						max-height: 16em;
						padding: 0;
						.list {
							line-height: 1.5;
							> * {
								padding: 1em;
								position: relative;
								display: block;
								&:last-child {
									border: none;
								}
							}
							label {
								position: absolute;
								right: 1em;
								bottom: 2em;
							}
							.cMain {
								width: 15em;
								margin: {
									bottom: 0.5em;
								}
								@extend %textCut;
							}
						}
					}
				}
				&:hover {
					//.dropList{opacity:1;pointer-events:auto;}
				}
			}
		}

		.user {
			min-width: 32px;
			padding: {
				right: 1.5em;
				left: 1em;
			}
			cursor: default;
			.face {
				width: 32px;
				height: 32px;
				display: inline-block;
				border-radius: 50%;
				background: no-repeat center;
				background-size: cover;
				cursor: pointer;
			}
			&:hover {
				/*box-shadow:0 0 4em rgba(#000,.1) inset;*/
				.list {
					pointer-events: auto;
					opacity: 1; /*transform:translateY(0);*/
				}
			}
			.dropList {
				min-width: 23em /*100%*/;
				position: absolute;
				border-radius: 0 0 $radius $radius;
				top: 100%;
				left: unset;
				right: 0.7em; /*box-shadow:0 5px 20px rgba(#000,.2);*/ /*transform:rotateX(90deg) perspective(200px);transform-origin:top;background-color:$mainColor;*/
				> * {
					width: 100%;
					padding: 1em 1.8rem;
					display: block;
					text-align: left;
					&:hover {
						/*background-color:rgba(#000,.1);*/
						color: inherit;
					}
					&:first-child:hover {
						background-color: inherit;
					}
					/*&:last-child{border-radius:0 0 $radius $radius;text-align:center;}*/
				}
				.face {
					width: 56px;
					height: 56px;
				}
			}
		}
		.dropList {
			border-top-left-radius: 0;
			border-top-right-radius: 0;
			> * {
				padding: {
					top: 1em;
					bottom: 1em;
				}
				line-height: 1.3;
			}
			$appWidth: 10em;
			&.appList {
				width: $appWidth * 5 + 2 + 0.2;
				padding: 0;
				box-shadow: none;
				.label {
					margin: {
						top: 0.1em;
					}
				}
				/*>svg{width:2em;min-width:unset;height:2em;padding:{top:0;bottom:0;left:0;right:0;};position:absolute;top:-.2em;transform:rotateX(180deg);z-index:1;}*/
				svg {
					position: unset;
					right: unset;
					opacity: 1;
				}
				.list {
					max-width: $appWidth * 6 + 2 + 0.2;
					padding: 1em;
					position: relative;
					@extend %boxShadowHigh;
					> *:hover {
						background-color: unset;
					}
				}
				a {
					width: $appWidth;
					min-width: unset;
					height: 8.5em;
					margin: {
						top: 0.5em;
					}
					padding: {
						left: 0.5em;
						right: 0.5em;
					}
					background-color: unset;
					display: inline-block;
					color: $fontContentColor;
					line-height: 1.2;
					text-align: center;
					white-space: unset;
					overflow: unset;
					&:hover {
						color: $mainColor;
						box-shadow: none;
					}
					.ico {
						width: 4em;
						height: 4em;
						margin: {
							left: auto;
							right: auto;
							bottom: 0.5em;
						}
						svg {
							width: 100%;
							height: 100%;
						}
					}
				}
			}
		}
	}
}
.errorNum {
	display: inline-block;
	position: absolute;
	left: 1.6em;
	top: -0.8em;
	padding: 3px;
	font-size: 12px;
	line-height: 12px;
	border-radius: 9px;
	min-width: 12px;
	text-align: center;
	box-sizing: content-box;
	word-break: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/frame/Head.vue